var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "url(#pattern0_17768_137579)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_17768_137579",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_17768_137579",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_17768_137579",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAZpJREFUeF7tmksOwjAMROl9WHEJzswlWHEfUJCQouCYEmrPlAzLovwmzxPH7XKY/LecT7f7zBosMy++rF0CtARkhcTleqQQXx4wPQEywUaB2gO2jtPIvkc3Uh7gecAUBIyi8y/t3s7iyDiN7Ht0Q+QB8oBRdv6knTwg6/LDCowIYN2ZrHnREeCF5NaZ6bMiJA8gug32MsXIDJKiLJUV79Y4rgdETsyKZwgB8gDHA6YgIHKRe+ibygTlAQBkRABAdKohd0dArd4rl2iP8jrH8P7TXYDt9fiaU6CNn7LbVjLXe17a14RQhQDCHKgEWENAL75Hn6segMCuNyaEACYBEHOBeYC12xACVA8AcLfm3B519bKcb0iChQBAd3PIdAG8Cm9k9bdHhvKAbBTpCMgWgG28dA9oY7G9nUUKZNEnD4hU3Ov7U6UmYl4mARED7alPiAfUAmWSIA8w0IQTkHUq9EijEADpGXQCRNwHPJ9RHoDEzxo74lRwCWATIHs+dB7g5Qi/imN9lyQP+FXV6PZbFW17X5lSh0C0uKX/B8rqaRC4TqSDAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.10971bfdc3fa497bd659315b351257e9.svg";
export { ForwardRef as ReactComponent };